import React from 'react';

export const RuMoreInfoModal = {
  title: 'Additional Tsunami Runup Information',
  body: (
    <div>
      <p>
        The Addl Runup Info link will display additional tsunami runup information in a new browser window such as the numbers of injuries and houses destroyed, the period, first motion, references and comments.
      </p>
    </div>
  ),
};
